import TimeLapseInput from './time-lapse-input';

export default TimeLapseInput;
